import React, { useEffect, useRef, useState } from "react";
import { CustomCard } from "../../../../../../../../Components";
import { Typography, Divider, Box, Avatar } from "@material-ui/core";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { getDownloadableLink } from "../../../../../../../../Helper";

// styles
import useStyles from "./styles";

// icons 
import {
  Image01Icon,
  PauseIcon,
  PlayButtonIcon,
} from "../../../../../../../../assets/icons";

function LocationVideoCard({ data }) {
  const styles = useStyles();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const videoRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  useEffect(() => {
    if (data?.videos?.[0]?.fileId) {
      const url = getDownloadableLink(data.videos[0].fileId);
      setVideoUrl(url);
    }
  }, [data]);

  return (
    <CustomCard
      borderRadius="md"
      borderColor="secondary"
      classes={styles.containerVedioCard}
    >
      <Box className={styles.containerHeaderCard}>
        <video
          ref={videoRef}
          className={styles.videoPreview}
          height="100%"
          width="100%"
          onClick={handlePlayPause}
        >
          <source src={videoUrl} type="video/mp4" />
          <source src={videoUrl} type="video/webm" />
          <source src={videoUrl} type="video/ogg" />
          Your browser does not support the video tag.
        </video>
        <Box
          className={styles.conatinerPlayPauseIcon}
          onClick={() => {
            handlePlayPause();
          }}
        >
          {isPlaying ? <PauseIcon /> : <PlayButtonIcon />}
        </Box>
      </Box>
      <Box className={styles.containerBodyCard}>
        <Box className={styles.sectionMnueCategoryName}>
          <Typography className={styles.containerCategoryName}>
            {data?.categoryName}
          </Typography>
        </Box>
        <Box className={styles.sectionCreatedBy}>
          <Box className={styles.containerItemAvatar}>
            <Avatar
              className={styles.AvatarStyle}
              src={"/images/contacts/MaleAvatar.svg"}
            ></Avatar>
          </Box>
          <Box className={styles.containerCreatedBy}>
            <Typography className={styles.createdByValue}>
              {data?.createdBy}
            </Typography>
            <Typography className={styles.createdByTitle}>
              {translate("Created-by")}
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box className={styles.containerInfoProprety}>
          <Box className={styles.containerCountImages}>
            <Image01Icon
              width="20"
              height="20"
              fill={palette.utility.utility_gray_400}
            />
            <Typography className={styles.totalCountValue}>
              {data?.videos?.length}
            </Typography>
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
}

export default LocationVideoCard;
